import React from "react";
import { motion } from "framer-motion";
import { useDashTheme } from "../../../hooks/useDashTheme";
import { useCatColors, fmtDur, MiniDayStrip, MiniColumns } from "../bits";
import { Sk, fmtShort } from "./storyBits";

/* Two measures the hero number does not already say. */

export function StoryPulse({ data, loading }) {
  const t = useDashTheme();
  const C = useCatColors();
  const totals = data?.totals;
  const sh = t.shadow.raised;

  if (loading || !totals) {
    return (
      <div className="st-pulse" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12, marginBottom: t.s[4] }}>
        {[0, 1].map((i) => <Sk key={i} h={148} r={16} />)}
      </div>
    );
  }

  const tiles = [
    {
      label: "Longest run",
      value: totals.longestBlockMin ? fmtShort(totals.longestBlockMin) : "—",
      foot: totals.longestBlockMin ? "unbroken stretch at the desk" : "no measured stretch",
      color: t.c.ai,
      chart: <MiniColumns values={(data.threads || []).map((th) => th.minutes)} color={t.c.ai} emptyNote="no threads" />,
    },
    {
      label: "Away",
      value: totals.awayMin ? fmtDur(totals.awayMin) : "None",
      foot: totals.awayMin ? "gaps in the tracked day" : "no gaps recorded",
      color: t.c.textTertiary,
      chart: <MiniDayStrip blocks={data.blocks} bounds={data.bounds} colors={C} />,
    },
  ];

  return (
    <div className="st-pulse" style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 12, marginBottom: t.s[4] }}>
      {tiles.map((k, i) => (
        <motion.div
          key={k.label}
          initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: t.motion.ease.out, delay: i * 0.05 }}
          style={{
            background: t.c.surface, border: `1px solid ${t.c.border}`, borderRadius: t.r.card,
            padding: "16px 16px 12px", boxShadow: sh, minHeight: 148,
            display: "flex", flexDirection: "column",
          }}
        >
          <div style={{ ...t.font.statLabel, color: t.c.primary }}>{k.label}</div>
          <div style={{
            fontSize: 28, fontWeight: 700, letterSpacing: "-1.2px", margin: "8px 0 2px",
            fontVariantNumeric: "tabular-nums",
          }}>{k.value}</div>
          <div style={{ fontSize: 12, color: t.c.textTertiary, lineHeight: 1.4 }}>{k.foot}</div>
          <div style={{ marginTop: "auto", paddingTop: 10, height: 36, display: "flex", alignItems: "flex-end" }}>
            {k.chart}
          </div>
        </motion.div>
      ))}
    </div>
  );
}
